// extracted by mini-css-extract-plugin
module.exports = {"ul":"VerticalNavigation_ul__10Eqj","active":"VerticalNavigation_active__1IJLX"};